import type { AIDraftSummaryResponse } from "@/hooks/api"

export interface AIDraftTimelineGroups {
  correlatedByPartId: Map<number, AIDraftSummaryResponse[]>
  uncorrelatedByAnchorId: Map<number, AIDraftSummaryResponse[]>
}

const newestDraftFirst = (
  left: AIDraftSummaryResponse,
  right: AIDraftSummaryResponse
) => right.created_at.localeCompare(left.created_at) || right.id - left.id

export const buildAIDraftTimelineGroups = (
  summaries: AIDraftSummaryResponse[]
): AIDraftTimelineGroups => {
  const draftsByAnchor = new Map<number, AIDraftSummaryResponse[]>()
  const correlatedByPartId = new Map<number, AIDraftSummaryResponse[]>()
  const uncorrelatedByAnchorId = new Map<number, AIDraftSummaryResponse[]>()

  for (const summary of summaries) {
    const group = draftsByAnchor.get(summary.context_through_part_id) ?? []
    group.push(summary)
    draftsByAnchor.set(summary.context_through_part_id, group)
  }

  for (const [anchorId, drafts] of draftsByAnchor) {
    const correlated = drafts.filter(
      (draft) => draft.correlated_conversation_part_id != null
    )
    const uncorrelated = drafts
      .filter((draft) => draft.correlated_conversation_part_id == null)
      .sort(newestDraftFirst)

    if (correlated.length === 1) {
      const correlatedDraft = correlated[0]
      correlatedByPartId.set(correlatedDraft.correlated_conversation_part_id!, [
        correlatedDraft,
        ...uncorrelated,
      ])
      continue
    }

    for (const draft of correlated.sort(newestDraftFirst)) {
      correlatedByPartId.set(draft.correlated_conversation_part_id!, [draft])
    }
    if (uncorrelated.length > 0) {
      uncorrelatedByAnchorId.set(anchorId, uncorrelated)
    }
  }

  return { correlatedByPartId, uncorrelatedByAnchorId }
}
